/* Vidéo parlée flottante « la cabine » (direction B validée le 02/10/2026).
   Aucune vidéo téléchargée avant que le mini-lecteur soit affiché ET visible ;
   affichage seulement après le chargement complet de la page. */
(function () {
  if (window.customElements && customElements.get('talk-video-float')) return;

  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function store(key, value) {
    try { if (value === undefined) return sessionStorage.getItem(key); sessionStorage.setItem(key, value); } catch (e) { return null; }
  }
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); return p; }
  function makeVideo(poster) {
    var v = document.createElement('video');
    v.muted = true; v.loop = true; v.playsInline = true; v.preload = 'none';
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
    if (poster) v.poster = poster;
    return v;
  }
  // HLS adaptatif d'abord (Safari, Chrome récents), MP4 en secours : le navigateur prend la 1re qu'il sait lire
  function load(el, v) {
    if (v.dataset.loaded) return;
    v.dataset.loaded = '1';
    [['hls', 'hlsType'], ['mp4', 'mp4Type']].forEach(function (k) {
      var url = el.dataset[k[0]];
      if (!url) return;
      var s = document.createElement('source');
      s.src = url; if (el.dataset[k[1]]) s.type = el.dataset[k[1]];
      v.appendChild(s);
    });
    v.load();
  }
  // Tracking (03/10/2026) : chaque action émet un évènement DOM « tvf:<action> » (détail : marché, produit) et
  // s'inscrit dans window.__tvfEvents ; les évènements personnalisés Intelligems (javascriptEvent) écoutent ces
  // signaux et les rattachent au groupe de test de la visiteuse.
  function emit(el, name) {
    try {
      (window.__tvfEvents = window.__tvfEvents || []).push(name);
      document.dispatchEvent(new CustomEvent('tvf:' + name, { detail: { market: (el && el.dataset.market) || '', product: (el && el.dataset.product) || '' } }));
      // marqueur invisible lu par les évènements Intelligems « élément vu » (.tvf-mark--<action>) ; opacité 0.01 et pas 0 :
      // Intelligems ignore un élément dont l'opacité calculée vaut « 0 ». Identifiant stable,
      // contrairement aux évènements JavaScript gérés dont l'identifiant change à chaque mise à jour
      var m = document.createElement('span');
      m.className = 'tvf-mark tvf-mark--' + name;
      m.setAttribute('aria-hidden', 'true');
      m.style.cssText = 'position:fixed;left:0;top:0;width:1px;height:1px;opacity:0.01;pointer-events:none;z-index:2147483647';
      document.body.appendChild(m);
      setTimeout(function () { if (m.parentNode) m.parentNode.removeChild(m); }, 5000);
    } catch (e) {}
  }
  function fmt(s) { s = Math.max(0, Math.floor(s || 0)); return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); }
  var LABELS = {
    de: { seek: 'Videoposition', play: 'Abspielen', pause: 'Pause' },
    fr: { seek: 'Position dans la vidéo', play: 'Lecture', pause: 'Pause' },
    en: { seek: 'Video position', play: 'Play', pause: 'Pause' }
  };
  // barre de lecture du lecteur en grand (lecture/pause, temps, piste qu'on touche ou qu'on glisse)
  function buildScrub(v, stage, onSeek) {
    var L = LABELS[(document.documentElement.lang || 'en').slice(0, 2)] || LABELS.en;
    var el = document.createElement('div');
    el.className = 'tvf-scrub';
    el.innerHTML = '<button type="button" class="tvf-scrub__pp"><svg class="tvf-scrub__ic-play" viewBox="0 0 14 14" aria-hidden="true"><path d="M3 1.5v11l9.5-5.5z"/></svg><svg class="tvf-scrub__ic-pause" viewBox="0 0 14 14" aria-hidden="true"><path d="M3 1.5h3v11H3zM8 1.5h3v11H8z"/></svg></button>' +
      '<span class="tvf-scrub__t">0:00</span>' +
      '<div class="tvf-scrub__track" role="slider" tabindex="0" aria-label="' + L.seek + '" aria-valuemin="0"><i class="tvf-scrub__fill"></i><b class="tvf-scrub__knob"></b></div>' +
      '<span class="tvf-scrub__d">0:00</span>';
    stage.appendChild(el);
    var pp = el.querySelector('.tvf-scrub__pp'), track = el.querySelector('.tvf-scrub__track'),
      fill = el.querySelector('.tvf-scrub__fill'), knob = el.querySelector('.tvf-scrub__knob'),
      tEl = el.querySelector('.tvf-scrub__t'), dEl = el.querySelector('.tvf-scrub__d');
    var scrubbing = false, wasPlaying = false;
    function update() {
      var d = v.duration || 0, t = v.currentTime || 0, pct = d ? Math.min(100, 100 * t / d) : 0;
      if (!scrubbing) { fill.style.width = pct + '%'; knob.style.left = pct + '%'; }
      tEl.textContent = fmt(t); if (d) dEl.textContent = fmt(d);
      track.setAttribute('aria-valuemax', Math.round(d)); track.setAttribute('aria-valuenow', Math.round(t)); track.setAttribute('aria-valuetext', fmt(t) + ' / ' + fmt(d));
      el.classList.toggle('is-paused', v.paused);
      pp.setAttribute('aria-label', v.paused ? L.play : L.pause);
    }
    function seekTo(clientX) {
      var r = track.getBoundingClientRect(), f = Math.max(0, Math.min(1, (clientX - r.left) / r.width));
      fill.style.width = (100 * f) + '%'; knob.style.left = (100 * f) + '%';
      if (v.duration) { try { v.currentTime = f * v.duration; } catch (e) {} tEl.textContent = fmt(f * v.duration); }
    }
    pp.addEventListener('click', function (e) { e.stopPropagation(); if (v.paused) play(v); else v.pause(); });
    track.addEventListener('pointerdown', function (e) {
      e.preventDefault(); e.stopPropagation();
      scrubbing = true; wasPlaying = !v.paused; v.pause();
      el.classList.add('is-scrubbing');
      if (track.setPointerCapture) { try { track.setPointerCapture(e.pointerId); } catch (err) {} }
      seekTo(e.clientX);
    });
    track.addEventListener('pointermove', function (e) { if (scrubbing) { e.preventDefault(); seekTo(e.clientX); } });
    var stop = function () { if (!scrubbing) return; scrubbing = false; el.classList.remove('is-scrubbing'); if (wasPlaying) play(v); update(); if (onSeek) onSeek(); };
    track.addEventListener('pointerup', stop); track.addEventListener('pointercancel', stop);
    track.addEventListener('click', function (e) { e.stopPropagation(); });
    track.addEventListener('keydown', function (e) {
      var step = e.key === 'ArrowRight' ? 5 : e.key === 'ArrowLeft' ? -5 : 0;
      if (!step || !v.duration) return;
      e.preventDefault(); v.currentTime = Math.max(0, Math.min(v.duration - 0.1, v.currentTime + step)); update(); if (onSeek) onSeek();
    });
    update();
    return { update: update };
  }
  function unload(v) { v.pause(); while (v.firstChild) v.removeChild(v.firstChild); v.removeAttribute('src'); v.load(); delete v.dataset.loaded; }

  class TalkVideoFloat extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      if (store(this.dataset.key) === '1') { this.remove(); return; }
      // sortir du flux de la galerie : un ancêtre transformé casserait position:fixed
      if (this.parentNode !== document.body) document.body.appendChild(this);
      var self = this;
      var go = function () { setTimeout(function () { self.show(); }, 400); };
      if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
    }

    show() {
      if (!this.isConnected) return;
      var mini = this.querySelector('.tvf__mini');
      this.removeAttribute('hidden');
      emit(this, 'shown');
      if (!reduced) this.classList.add('tvf--enter');

      this.querySelector('.tvf__x').addEventListener('click', this.dismiss.bind(this));
      this.querySelector('.tvf__open').addEventListener('click', this.openPlayer.bind(this));

      this.trackBottom();
      this.restorePos();
      this.enableDrag();

      if (reduced) return; // image fixe : pas de lecture automatique
      var v = makeVideo(this.dataset.poster);
      mini.insertBefore(v, mini.firstChild);
      this.miniVideo = v;
      var bar = this.querySelector('.tvf__bar i');
      v.addEventListener('timeupdate', function () { if (v.duration) bar.style.width = (100 * v.currentTime / v.duration) + '%'; });
      v.addEventListener('playing', function () { var s = mini.querySelector('.tvf__still'); if (s) s.style.visibility = 'hidden'; }, { once: true });
      var self = this;
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && !self.playerOpen) { load(self, v); play(v); }
            else if (!self.playerOpen) v.pause();
          });
        }, { threshold: 0.2 });
        this.io.observe(this);
      } else { load(this, v); play(v); }
      document.addEventListener('visibilitychange', function () { if (document.hidden) v.pause(); else if (!self.playerOpen && v.dataset.loaded) play(v); });
    }

    // au-dessus de la barre d'achat collante quand elle est affichée (mobile)
    trackBottom() {
      var self = this, quick = document.querySelector('.product-quick-add, .nk-sticky'), raf = 0, idle = 0, lastY = window.pageYOffset;
      var update = function () {
        raf = 0;
        var dy = window.pageYOffset - lastY;
        lastY = window.pageYOffset;
        if (window.innerWidth >= 1000) { self.style.removeProperty('--tvf-bottom'); self.classList.remove('tvf--avoid'); return; }
        // place fixe au-dessus de la barre d'achat collante, qu'elle soit affichée ou non : la barre se cache quand le
        // bouton panier est à l'écran, et le lecteur ne doit pas monter et descendre avec elle (05/10/2026)
        var bottom = 16;
        if (quick && getComputedStyle(quick).display !== 'none' && quick.offsetHeight > 0) {
          bottom = Math.max(16, quick.offsetHeight + (parseFloat(getComputedStyle(quick).bottom) || 0) + 12);
        }
        self.style.setProperty('--tvf-bottom', bottom + 'px');
        if (self.playerOpen) return;
        // 04/10/2026 (Mathis) : ne jamais recouvrir le choix de taille, le bloc d'offres groupées ni le bouton panier.
        // 05/10/2026 (Mathis) : le lecteur reste FIXE, il ne suit jamais la page (le faire remonter au-dessus des zones
        // donnait l'impression qu'il traînait derrière le défilement). Quand une zone passe sous lui, il s'efface.
        var zones = [];
        var picker = document.querySelector('.nk-pdp-info .nk-picker');
        if (picker) {
          var pr0 = picker.getBoundingClientRect(), calc = document.querySelector('.nk-pdp-info [data-nkd-sizecalc]');
          var cr = calc ? calc.getBoundingClientRect() : null;
          zones.push({ top: cr ? Math.min(cr.top, pr0.top) : pr0.top, bottom: pr0.bottom }); // carte « Trouver ma taille » + tailles
        }
        var njb = document.querySelector('.nk-pdp-info [data-njb]');
        if (njb) { var nr = njb.getBoundingClientRect(); if (nr.height > 0) zones.push({ top: nr.top, bottom: nr.bottom }); }
        var atc = document.querySelector('.nk-pdp-info .nk-buy button[type="submit"]');
        if (atc) { var ar = atc.getBoundingClientRect(); if (ar.height > 0) zones.push({ top: ar.top, bottom: ar.bottom }); }
        var userBottom = parseFloat(self.style.getPropertyValue('--tvf-user-bottom')) || 0;
        var bot = window.innerHeight - Math.max(bottom, userBottom), top = bot - (self.offsetHeight || 144); // le lecteur à l'écran
        // il s'efface un peu avant la zone, dans le sens du défilement : sur iPhone le script voit l'écran avec une image de retard
        var ahead = Math.min(120, Math.abs(dy) * 2), below = dy > 0 ? ahead : 0, above = dy < 0 ? ahead : 0;
        self.classList.toggle('tvf--avoid', zones.some(function (z) { return bot > z.top - 8 - below && top < z.bottom + 8 + above; }));
      };
      var schedule = function () { if (!raf) raf = requestAnimationFrame(update); };
      // défilement arrêté : on revérifie sans l'anticipation (il revient si la zone ne l'a finalement pas atteint)
      window.addEventListener('scroll', function () { clearTimeout(idle); idle = setTimeout(schedule, 160); }, { passive: true });
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      if (quick && 'MutationObserver' in window) new MutationObserver(schedule).observe(quick, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      if (quick) quick.addEventListener('transitionend', schedule);
      update();
      setTimeout(schedule, 600);
    }

    // position choisie par la visiteuse (appui long + glisser), gardée pour la visite
    restorePos() {
      var pos = null;
      try { pos = JSON.parse(store('tvf-pos') || 'null'); } catch (e) {}
      if (pos) this.applyPos(pos.side, pos.bottom);
    }
    applyPos(side, bottom) {
      this.classList.toggle('tvf--left', side === 'left');
      this.classList.toggle('tvf--right', side === 'right');
      if (bottom > 0) this.style.setProperty('--tvf-user-bottom', bottom + 'px');
    }

    // appui long (~0,4 s) = on attrape le lecteur ; on le lâche = il se cale sur le bord le plus proche
    enableDrag() {
      var self = this, hit = this.querySelector('.tvf__open');
      var timer = 0, dragging = false, sx = 0, sy = 0, rect = null, pid = null;
      var cancelTimer = function () { if (timer) { clearTimeout(timer); timer = 0; } };
      var end = function (e) {
        cancelTimer();
        if (!dragging) return;
        dragging = false;
        if (pid !== null && hit.releasePointerCapture) { try { hit.releasePointerCapture(pid); } catch (err) {} }
        var r = self.getBoundingClientRect(), vw = window.innerWidth, vh = window.innerHeight;
        var side = (r.left + r.width / 2) < vw / 2 ? 'left' : 'right';
        var header = document.querySelector('.header, header'), minTop = (header ? header.getBoundingClientRect().bottom : 0) + 12;
        var bottom = Math.round(vh - r.bottom);
        bottom = Math.max(16, Math.min(bottom, Math.round(vh - minTop - r.height)));
        self.classList.remove('tvf--drag');
        self.style.transform = '';
        self.applyPos(side, bottom);
        store('tvf-pos', JSON.stringify({ side: side, bottom: bottom }));
        emit(self, 'drag');
        // le clic qui suit le relâcher ne doit pas ouvrir la vidéo
        self.dragged = true;
        setTimeout(function () { self.dragged = false; }, 400);
      };
      hit.addEventListener('pointerdown', function (e) {
        if (e.button > 0 || self.playerOpen) return;
        sx = e.clientX; sy = e.clientY; pid = e.pointerId;
        cancelTimer();
        timer = setTimeout(function () {
          timer = 0; dragging = true;
          rect = self.getBoundingClientRect();
          self.classList.remove('tvf--enter');
          self.classList.add('tvf--drag');
          if (hit.setPointerCapture) { try { hit.setPointerCapture(pid); } catch (err) {} }
          if (navigator.vibrate) { try { navigator.vibrate(12); } catch (err) {} }
        }, 380);
      });
      hit.addEventListener('pointermove', function (e) {
        if (!dragging) {
          if (timer && (Math.abs(e.clientX - sx) > 8 || Math.abs(e.clientY - sy) > 8)) cancelTimer(); // c'est un défilement
          return;
        }
        e.preventDefault();
        var dx = e.clientX - sx, dy = e.clientY - sy, vw = window.innerWidth, vh = window.innerHeight;
        dx = Math.max(8 - rect.left, Math.min(dx, vw - 8 - rect.right));
        dy = Math.max(8 - rect.top, Math.min(dy, vh - 8 - rect.bottom));
        self.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
      });
      hit.addEventListener('pointerup', end);
      hit.addEventListener('pointercancel', end);
      // iPhone : empêcher la page de défiler pendant qu'on déplace le lecteur
      hit.addEventListener('touchmove', function (e) { if (dragging || timer) { if (dragging) e.preventDefault(); } }, { passive: false });
      this.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    }

    dismiss(event) {
      if (event) { event.preventDefault(); event.stopPropagation(); }
      emit(this, 'dismiss');
      store(this.dataset.key, '1');
      if (this.miniVideo) unload(this.miniVideo);
      if (this.io) this.io.disconnect();
      this.remove();
    }

    openPlayer(event) {
      if (event) event.preventDefault();
      if (this.dragged) { this.dragged = false; return; } // fin d'un déplacement, pas un tap
      if (this.playerOpen) return;
      this.playerOpen = true;
      emit(this, 'open');
      var self = this;
      this.style.visibility = 'hidden';
      this.lastFocus = document.activeElement;

      var tpl = this.querySelector('.tvf__tpl');
      var player = tpl.content.firstElementChild.cloneNode(true);
      var stage = player.querySelector('.tvf-player__stage');
      // On RÉUTILISE la vidéo du mini-lecteur (déjà chargée, déjà décodée) : une 2e vidéo
      // HLS créée au tap restait en écran noir sur iPhone (bug vu par Mathis le 02/10).
      var v = this.miniVideo && this.miniVideo.dataset.loaded ? this.miniVideo : null;
      this.reused = !!v;
      if (!v) {
        v = makeVideo(this.dataset.posterFull || this.dataset.poster);
        load(this, v);
      }
      v.loop = true;
      stage.appendChild(v);
      document.body.appendChild(player);
      document.documentElement.classList.add('tvf-lock');
      requestAnimationFrame(function () { player.classList.add('is-on'); });
      this.player = player; this.fullVideo = v;

      // le bouton reprend la couleur réelle du bouton d'achat de la fiche (réglages du thème)
      var ref = document.querySelector('.nk-sticky button[type="submit"], .nk-buy button[type="submit"]');
      var cta = player.querySelector('.tvf-player__cta');
      if (ref && cta) {
        var bg = getComputedStyle(ref).backgroundColor, txt = (ref.style.getPropertyValue('--button-text-color') || '').trim();
        if (bg && bg !== 'rgba(0, 0, 0, 0)') { cta.style.background = bg; cta.style.borderColor = bg; }
        cta.style.color = txt ? 'rgb(' + txt + ')' : '#fff';
      }
      var sound = player.querySelector('.tvf-player__sound'), bar = player.querySelector('.tvf-player__bar i');
      var setSound = function () {
        sound.classList.toggle('is-muted', v.muted);
        sound.setAttribute('aria-label', v.muted ? self.dataset.soundOn : self.dataset.soundOff);
      };
      // ouverture = geste de l'utilisatrice : lecture AVEC le son, depuis le début ; repli muet si le navigateur refuse
      v.muted = false; v.removeAttribute('muted');
      try { v.currentTime = 0; } catch (e) {}
      var p = play(v);
      if (p && p.catch) p.catch(function () { v.muted = true; setSound(); play(v); });
      setSound();
      // barre de lecture : toucher pour sauter à un moment, glisser pour revenir sur un passage
      var halfSent = false, seekSent = false;
      var scrub = buildScrub(v, stage, function () { if (!seekSent) { seekSent = true; emit(self, 'seek'); } });
      this.onFullTime = function () {
        if (v.duration) {
          bar.style.width = (100 * v.currentTime / v.duration) + '%';
          if (!halfSent && v.currentTime / v.duration >= 0.5) { halfSent = true; emit(self, 'half'); }
        }
        scrub.update();
      };
      v.addEventListener('timeupdate', this.onFullTime);
      this.onFullState = scrub.update;
      v.addEventListener('play', scrub.update); v.addEventListener('pause', scrub.update); v.addEventListener('loadedmetadata', scrub.update);
      // toucher la vidéo = pause / reprise
      v.addEventListener('click', this.onVideoTap = function () { if (v.paused) play(v); else v.pause(); });
      sound.addEventListener('click', function () { v.muted = !v.muted; if (!v.muted) play(v); setSound(); });
      player.querySelector('.tvf-player__close').addEventListener('click', function () { self.closePlayer(); });
      player.querySelector('.tvf-player__cta').addEventListener('click', function () { emit(self, 'cta'); self.closePlayer(true); self.toSizes(); });
      player.addEventListener('click', function (e) { if (e.target === player) self.closePlayer(); });
      this.onKey = function (e) { if (e.key === 'Escape') self.closePlayer(); };
      document.addEventListener('keydown', this.onKey);
      player.querySelector('.tvf-player__close').focus({ preventScroll: true });
    }

    closePlayer(skipFocus) {
      if (!this.playerOpen) return;
      this.playerOpen = false;
      var player = this.player, v = this.fullVideo;
      if (v && this.onFullTime) v.removeEventListener('timeupdate', this.onFullTime);
      if (v && this.onFullState) { ['play', 'pause', 'loadedmetadata'].forEach(function (n) { v.removeEventListener(n, this.onFullState); }, this); }
      if (v && this.onVideoTap) v.removeEventListener('click', this.onVideoTap);
      if (v && this.reused) {
        // la vidéo retourne dans le mini-lecteur, muette, et continue de tourner
        v.muted = true; v.setAttribute('muted', '');
        var mini = this.querySelector('.tvf__mini');
        mini.insertBefore(v, mini.firstChild);
      } else if (v) unload(v);
      document.removeEventListener('keydown', this.onKey);
      document.documentElement.classList.remove('tvf-lock');
      if (player) player.remove();
      this.style.visibility = '';
      this.player = this.fullVideo = null;
      this.reused = false;
      if (this.miniVideo && this.miniVideo.dataset.loaded && !document.hidden) play(this.miniVideo);
      if (!skipFocus && this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    }

    toSizes() {
      var target = document.querySelector('.nk-pdp-info .nk-opt') || document.querySelector('.nk-buy') || document.querySelector('.nk-pdp-info');
      if (!target) return;
      var header = document.querySelector('.header, header');
      var offset = (header ? header.getBoundingClientRect().height : 0) + 24;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: reduced ? 'auto' : 'smooth' });
      target.classList.add('tvf-flash');
      setTimeout(function () { target.classList.remove('tvf-flash'); }, 1600);
    }
  }

  if (window.customElements) customElements.define('talk-video-float', TalkVideoFloat);
})();
